<template>
  <div
    ref="wrapper"
    class="w-full aspect-[4/3] relative rounded-md object-cover h-auto"
  >
    <blurhash-img

      :blurhash="blurhash"
      class="absolute top-0 left-0 transition-opacity duration-1000 w-full aspect-[4/3] rounded-md "
      :class="[showImage ? 'opacity-0' : 'opacity-100 ', src === null ? 'animate-pulse' : '']"
    />
    <img

      ref="image"
      class="absolute top-0 left-0 transition-opacity duration-2000 aspect-[4/3] h-auto rounded-md object-cover bottom-0 border"
      :class="[showImage ? 'opacity-100' : 'opacity-0']"
      :style="style"
    >
  </div>
</template>

<script setup>
import { computed, onMounted, ref, toRefs, watch } from 'vue'
import BlurhashImg from './MediaBlurhashImg.vue'
import { useElementVisibility } from '@vueuse/core'

const props = defineProps({
  src: {
    type: [String, null],
    required: true
  },
  alt: {
    type: String,
    required: true
  },
  isNew: {
    type: Boolean,
    default: false
  },
  blurhash: {
    type: String,
    required: false,
    default: null
  },
  width: {
    type: Number,
    default: 1
  },
  height: {
    type: Number,
    default: 1
  },
  maxHeight: {
    type: Number,
    default: 1
  }
})

const { src, blurhash } = toRefs(props)

const image = ref()
const isLoaded = ref(false)

const emit = defineEmits(['click'])

const wrapper = ref(null)
const targetIsVisible = useElementVisibility(wrapper)

const onEnter = () => {
  isLoaded.value = false
  if (src.value !== null) {
    image.value.src = src.value
    image.value.onload = () => {
      setTimeout(() => {
        isLoaded.value = true
      }, 1000)
    }
  }
}

watch(src, async () => {
  onEnter()
})

const style = computed(() => {
  if (props.height === 0) {
    return { width: `${props.width}px`, maxHeight: `${props.maxHeight}px` }
  }
  return { width: `${props.width}px`, height: `${props.height}px` }
})

const showImage = computed(() => src.value !== null && (targetIsVisible.value || isLoaded.value))
onMounted(() => onEnter())

</script>
